export enum HttpErrorCode {
  UNKNOWN_ERROR = 500,
  MISSING_PARAMETERS = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  METHOD_NOT_ALLOWED = 405,
  TOO_MANY_REQUESTS = 429,
}
